import styled from "styled-components";
import {mq} from './util/media';

const Title = styled.h2`
  font-weight: 900;
  line-height: 1;
  margin: 0;
  font-size: 68px;
  margin-bottom: 50px;
  

  ${mq.lt.md} {
    font-size: 40px;
    margin-bottom: 18px;
  }

  ${mq.lt.sm} {
    font-size: 30px;
    text-align: center;
    margin-bottom: 34px;
  }

  ${props => props.constrain && `
    max-width: 14ch;
  `}
  
`

function SectionTitle(props) {

  return(
    <Title constrain={props.constrain}>
      {props.children}
    </Title>

  )
}

export default SectionTitle;